// libs
import { styled } from '@nykaa/ui-components';

// components
import Wishlist from 'shared/components/Wishlist';
import ModelWidget from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/ModelWidget';
import BasePromotionText from 'shared/components/PromotionText';

// constants
import { BREAKPOINTS, DWEB_MAX_WIDTH } from 'shared/styles/base';

export const Container = styled.div<{
  showColorsSizesSeperator: boolean;
  isWishlistEnabled: boolean;
}>`
  flex: 1;
  flex-shrink: 1;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing50} ${theme.spacing.spacing120} 0`};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100%;
    padding: 0;
  }

  .actionContainer {
    ${({ isWishlistEnabled }) => isWishlistEnabled && `width: 100%`};

    & .nd-email {
      ${({ isWishlistEnabled }) => isWishlistEnabled && `width: 209px`};
    }

    & .notify-btn {
      ${({ isWishlistEnabled }) => isWishlistEnabled && `min-width: 113px`};
    }
  }

  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    padding: 0;
    .actionContainer {
      & .nd-email {
        width: 100%;
      }
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const OutOfStockHelperText = styled.div`
  width: 100%;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: ${({ theme }) => theme.spacing.spacing60};
`;

export const Separator20 = styled.div`
  margin: ${({ theme }) => `${theme.spacing.spacing100} 0`};
  border-top: solid 1px ${({ theme }) => theme.colors.textOutline};
`;

export const PrimaryContent = styled.section`
  width: 100%;
  overflow: hidden;
`;

// we can use this to style the model widget
export const CustomModelWidget = styled(ModelWidget)`
  ${({ theme }) => `
    margin: ${theme.spacing.spacing80} 0 ${theme.spacing.spacing80};
  `};
`;

export const CustomWishlist = styled(Wishlist)`
  width: max-content;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  margin-right: ${({ theme }) => theme.spacing.spacing80};
  display: flex;
  cursor: pointer;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    min-width: 206px;
    .toastBox {
      bottom: 40px;

      .toast-mob-container {
        width: 320px;
        background-color: ${({ theme }) => theme.colors.primary};
        ${({ theme }) => theme.typography.bodyLarge};
      }
    }
  }
  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing80};
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

export const ProductOffersContainer = styled.div<{ height: number }>`
  height: ${({ height }) => `${height}px`};
  transition: height 0.3s ease-in-out;
`;

export const PromotionText = styled(BasePromotionText)`
  ${({ theme }) => theme.typography.bodySmall};
`;
